import { Typography } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';

import { Color, Level } from 'theme/enums';

interface IProps {
  message: string;
}

export const SectionWarning = ({ message }: IProps) => (
  <Typography level={Level.BODY_SM} color={Color.DANGER} startDecorator={<Warning size={16} />}>
    {message}
  </Typography>
);
